import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles.css';

import cePune from '../../assets/icons/logo-cepune.png';

function Navbar() {

  const navigate = useNavigate();
  const location = useLocation();

  const handleSignin = () => {
    navigate('/signIn');
    setMobileMenuOpen(false);
  };

  const [scrolled, setScrolled] = useState(false);
  const [user, setUser] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    // Check user login
    const storedUser = localStorage.getItem("user");
    if (storedUser && storedUser !== "undefined" && storedUser !== "null") {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Error parsing stored user from localStorage:", e);
        localStorage.removeItem("user");
      }
    }

    // Poll live status every 60 seconds so the LIVE button
    // activates automatically without needing a page refresh
    const checkLiveStatus = async () => {
      try {
        const ytPromise = fetch(`${process.env.REACT_APP_API_URL || 'https://ceindiazone2.in'}/api/youtube/status`)
          .then(res => res.json())
          .then(data => !!(data && data.isLive))
          .catch(() => false);

        const hlsPromise = fetch('https://cdn.itassist.one/church/stream/index.m3u8', { cache: 'no-store' })
          .then(res => res.ok)
          .catch(() => false);

        const [ytLive, hlsLive] = await Promise.all([ytPromise, hlsPromise]);
        setIsLive(ytLive || hlsLive);
      } catch {
        setIsLive(false);
      }
    };

    checkLiveStatus(); // Run immediately on mount
    const liveInterval = setInterval(checkLiveStatus, 60000); // then every 60s

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      clearInterval(liveInterval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Navigation handlers
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleHomeClick = () => {
    if (location.pathname === '/') {
      // Already on home page, scroll to header
      scrollToSection('header');
    } else {
      // Navigate to home page
      navigate('/');
      // Scroll to header after navigation
      setTimeout(() => scrollToSection('header'), 100);
    }
  };

  const handleFoundationClick = () => {
    navigate('/foundation-course');
    window.scrollTo(0, 0); // Ensure the new page starts at the top
  };

  const handleFellowshipsClick = () => {
    navigate('/fellowships');
    window.scrollTo(0, 0);
  };

  const handleAboutClick = () => {
    navigate('/about');
  };

  const handleLoveworldSingersClick = () => {
    navigate('/loveworld-singers');
  };

  const handleYouthChurchClick = () => {
    navigate('/youth-church');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleChildrensChurchClick = () => {
    navigate('/childrens-church');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleSocialServicesClick = () => {
    navigate('/social-services');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handlePastServicesClick = () => {
    navigate('/past-services');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleServiceClick = () => {
    if (location.pathname === '/') {
      // Already on home page, scroll to service section
      scrollToSection('service');
    } else {
      // Navigate to home page with service hash
      navigate('/#service');
      // Scroll to service after navigation
      setTimeout(() => scrollToSection('service'), 100);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      {/* <div className="container"> */}
        <div className="navbar-con">
          <div className="logo"><img src={cePune} alt="CE Pune Logo" fetchpriority="high" /></div>

          <ul className="nav-links">
            <li 
              onClick={handleHomeClick} 
              className={location.pathname === '/' && !location.hash ? 'active' : ''}
              style={{ cursor: 'pointer' }}
            >
              Home
            </li>
            <li 
              onClick={handleFoundationClick} 
              className={location.pathname === '/foundation-course' ? 'active' : ''}
              style={{ cursor: 'pointer' }}
            >
              Foundation School
            </li>
            <li 
              onClick={handleFellowshipsClick} 
              className={location.pathname === '/fellowships' ? 'active' : ''}
              style={{ cursor: 'pointer' }}
            >
              Fellowships
            </li>
            <li 
              onClick={handleAboutClick} 
              className={location.pathname === '/about' ? 'active' : ''}
              style={{ cursor: 'pointer' }}
            >
              About Us
            </li>
            <li className="nav-dropdown">
              Ministries ▼
              <ul className="nav-dropdown-content">
                <li 
                  onClick={handleLoveworldSingersClick} 
                  className={location.pathname === '/loveworld-singers' ? 'active' : ''}
                  style={{ cursor: 'pointer' }}
                >
                  Loveworld Singers
                </li>
                <li 
                  onClick={handleYouthChurchClick} 
                  className={location.pathname === '/youth-church' ? 'active' : ''}
                  style={{ cursor: 'pointer' }}
                >
                  Youth Ministry
                </li>
                <li 
                  onClick={handleChildrensChurchClick} 
                  className={location.pathname === '/childrens-church' ? 'active' : ''}
                  style={{ cursor: 'pointer' }}
                >
                  Childrens Ministry
                </li>
                <li 
                  onClick={handleSocialServicesClick} 
                  className={location.pathname === '/social-services' ? 'active' : ''}
                  style={{ cursor: 'pointer' }}
                >
                  Social Services
                </li>
              </ul>
            </li>

            <li 
              onClick={handlePastServicesClick} 
              className={location.pathname === '/past-services' ? 'active' : ''}
              style={{ cursor: 'pointer' }}
            >
              Service Archive
            </li>

            <li 
              onClick={handleServiceClick} 
              className={`live-service-item ${isLive ? 'is-live' : 'is-offline'}`}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              <span className={`pulsating-dot ${isLive ? 'is-live' : 'is-offline'}`}></span> Live
            </li>

          </ul>

          <div className="nav-right">
            {/* Desktop Buttons */}
            <div className="desktop-only" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>

              {user && user.role === 'ADMIN' && (
                <button
                  className="signup-button"
                  onClick={() => navigate('/admin/dashboard')}
                  style={{ backgroundColor: '#27ae60' }}
                >
                  Report
                </button>
              )}

              {user ? (
                <button
                  className="signup-button"
                  style={{ backgroundColor: '#e74c3c' }}
                  onClick={() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("adminUser");
                    window.location.reload();
                  }}
                >
                  Logout
                </button>
              ) : (
                <button className="signup-button" onClick={handleSignin}>Sign In</button>
              )}
            </div>

            {/* Hamburger Menu Button */}
            <button
              className="hamburger-menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          {/* Mobile Menu */}
          <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
            <ul className="mobile-nav-links">
              <li 
                onClick={() => { handleHomeClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/' && !location.hash ? 'active' : ''}
              >
                Home
              </li>
              <li 
                onClick={() => { handleFoundationClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/foundation-course' ? 'active' : ''}
              >
                Foundation School
              </li>
              <li 
                onClick={() => { handleFellowshipsClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/fellowships' ? 'active' : ''}
              >
                Fellowships
              </li>
              <li 
                onClick={() => { handleAboutClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/about' ? 'active' : ''}
              >
                About Us
              </li>
              <li 
                onClick={() => { handleLoveworldSingersClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/loveworld-singers' ? 'active' : ''}
              >
                Loveworld Singers
              </li>

              <li 
                onClick={() => { handleYouthChurchClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/youth-church' ? 'active' : ''}
              >
                Youth Ministry
              </li>

              <li 
                onClick={() => { handleChildrensChurchClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/childrens-church' ? 'active' : ''}
              >
                Childrens Ministry
              </li>

              <li 
                onClick={() => { handleSocialServicesClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/social-services' ? 'active' : ''}
              >
                Social Services
              </li>

              <li 
                onClick={() => { handlePastServicesClick(); setMobileMenuOpen(false); }}
                className={location.pathname === '/past-services' ? 'active' : ''}
              >
                Service Archive
              </li>

              <li 
                onClick={() => { handleServiceClick(); setMobileMenuOpen(false); }}
                className={`live-service-item ${isLive ? 'is-live' : 'is-offline'}`}
                style={{ fontWeight: 'bold' }}
              >
                <span className={`pulsating-dot ${isLive ? 'is-live' : 'is-offline'}`}></span> Live
              </li>
            </ul>



            <div className="mobile-buttons">
              {user && user.role === 'ADMIN' && (
                <button
                  className="signup-button"
                  onClick={() => { navigate('/admin/dashboard'); setMobileMenuOpen(false); }}
                  style={{ backgroundColor: '#27ae60' }}
                >
                  Report
                </button>
              )}

              {user ? (
                <button
                  className="signup-button"
                  style={{ backgroundColor: '#e74c3c' }}
                  onClick={() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("adminUser");
                    window.location.reload();
                  }}
                >
                  Logout
                </button>
              ) : (
                <button className="signup-button" onClick={handleSignin}>Sign In</button>
              )}
            </div>
          </div>
        </div>
      {/* </div> */}
    </nav>
  );
}

export default Navbar;
